export default (n1, n2) => {
    // JS automatic type coercion would take care of that, but let's be explicit
    if (typeof n2 === 'string') {
        n2 = parseFloat(n2);
    }
    if (typeof n1 === 'number' && typeof n2 !== 'number') {
        return true;
    }
    if (typeof n1 !== 'number' && typeof n2 === 'number') {
        return false;
    }
    return n1 > n2;
};
